import { render, staticRenderFns } from "./TabDataTable.vue?vue&type=template&id=7238b324&scoped=true"
import script from "./TabDataTable.vue?vue&type=script&lang=js"
export * from "./TabDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238b324",
  null
  
)

export default component.exports